import { footer } from "../data/content";

export default function Footer() {
  return (
    <footer className="border-t border-hairline" data-testid="footer">
      <div className="container-x py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2">
        <p className="text-sm text-faint">{footer.line}</p>
        <p className="font-mono text-xs tracking-wide text-faint">{footer.note}</p>
      </div>
    </footer>
  );
}
